/** The Miro MCP tools no grant gives, for any role (spec section 6). Sharing
 * tools would let the agent hand the board, or a space, to someone else, and
 * cross-board tools reach past the granted board into the team. */
export const MIRO_AI_BLOCKED_TOOLS = [
  "board_move_to_team",
  "board_role_update",
  "board_search_boards",
  "board_share",
  "space_create",
  "space_list",
  "space_list_boards",
  "space_list_children",
  "space_role_update",
  "space_share",
  "space_update_metadata",
  "user_search_organization_users",
] as const;

/** The Miro MCP tools a grant gives, one gateway entitlement row each. Miro
 * enforces the board role, so a `viewer` grant gets the write tools too, and
 * Miro refuses those calls.
 *
 * Every tool Miro's MCP listed through the gateway on 2026-11-02 (INT-1106),
 * less {@link MIRO_AI_BLOCKED_TOOLS}. The `miroBoard` server spec (INT-1113)
 * lists the same tools, with their schemas. */
export const MIRO_AI_GRANTED_TOOLS = [
  "board_create",
  "board_create_format",
  "board_get_space",
  "board_move",
  "board_restore",
  "board_update_metadata",
  "canvas_create_from_svg",
  "canvas_get_canvas_composer_skill",
  "canvas_get_html_upload_url",
  "canvas_load_format_skill",
  "canvas_read_as_svg",
  "canvas_search",
  "canvas_update_from_svg",
  "comment_create",
  "comment_list_comments",
  "comment_reply",
  "comment_resolve",
  "content_item_list_roles",
  "content_search",
  "create_boardcast",
  "get_brand_context",
  "image_create",
  "image_get_data",
  "image_get_upload_url",
  "image_get_url",
  "prototype_create",
  "prototype_get_upload_url",
  "prototype_read",
  "section_create",
  "section_delete",
  "section_update_metadata",
  "table_create",
  "table_get_latest_update_history",
  "table_list_rows",
  "table_sync_rows",
  "table_update_view",
  "user_who_am_i",
] as const;
